import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { User } from '../contracts/user.interface';
import { TableFilter } from '../../shared/contracts/table-column.interface';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private baseUrl = 'users/';

  constructor(private http: HttpClient) {}

  getAll(page = 1, size = 10, filters: TableFilter[] = []): Observable<{ data: User[]; total: number }> {
    let params = new HttpParams().set('page', page).set('size', size);
    for (const f of filters) {
      params = params.append('filter_field', f.field);
      params = params.append('filter_value', f.value);
      params = params.append('filter_match', f.matchMode);
    }
    return this.http.get<{ data: User[]; total: number }>(this.baseUrl, { params });
  }

  getById(id: number): Observable<User> {
    return this.http.get<User>(`${this.baseUrl}${id}`);
  }

  // Get current user profile
  getCurrentUser(): Observable<User> {
    return this.http.get<User>(`${this.baseUrl}me`);
  }

  create(tenant: User): Observable<User> {
    return this.http.post<User>(this.baseUrl, tenant);
  }

  update(id: number, tenant: User): Observable<User> {
    return this.http.put<User>(`${this.baseUrl}${id}`, tenant);
  }

  // Update current user profile
  updateCurrentUser(userData: Partial<User>): Observable<User> {
    return this.http.put<User>(`${this.baseUrl}me`, userData);
  }

  delete(id: number): Observable<User> {
    return this.http.delete<User>(`${this.baseUrl}${id}`);
  }

  upload(id: number, formData: any): Observable<any> {
    return this.http.post<string>(`${this.baseUrl}${id}/image`, formData);
  }

  getSettings(): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}settings`);
  }

  updateSettings(data: any): Observable<any> {
    return this.http.put<any>(`${this.baseUrl}settings`, data);
  }
}
